const config = require('lc-config');
const defaultConfig = require('../config/logger-default');
const Logger = require('./logger');

config.util.setModuleDefaults('logger', defaultConfig);

const port =
  process.env.PORT ||
  (config.has('boreas.port') ? config.get('boreas.port') : 0);

const options = {
  appName: config.get('appName'),
  env: process.env.NODE_ENV || 'development',
  port,
  filePath: config.get('logger.filePath'),
  consoleStream: config.get('logger.console'),
  prettyStream: config.get('logger.prettyStream'),
  logLevel: config.get('logger.level'),
  consoleOverrides: config.get('logger.consoleOverrides'),
  rotatePeriod: config.get('logger.rotatePeriod'),
  rotateDepth: config.get('logger.rotateDepth'),
  ringBufferLimit: config.get('logger.ringBufferLimit'),
  serializers: config.get('logger.serializers'),
};
if (!global._logger) {
  config.util.setModuleDefaults('logger', defaultConfig);
  global._logger = new Logger(options);
}

const optionsIL = {
  appName: config.get('appName'),
  env: process.env.NODE_ENV || 'development',
  port,
  filePath: config.get('logger.internalLoggerFilePath'),
  consoleStream: config.get('logger.console'),
  prettyStream: config.get('logger.prettyStream'),
  logLevel: config.get('logger.level'),
  consoleOverrides: config.get('logger.consoleOverrides'),
  rotatePeriod: config.get('logger.rotatePeriod'),
  rotateDepth: config.get('logger.rotateDepth'),
  ringBufferLimit: config.get('logger.ringBufferLimit'),
  serializers: config.get('logger.serializers'),
};
if (!global._internalLogger) {
  global._internalLogger = new Logger(optionsIL);
}
module.exports = {
  logger: global._logger,
  internalLogger: global._internalLogger,
};

